import { Component } from '@angular/core';
import { OrganisationRequestInterface } from '@careapp/angular-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { FormMode } from '../../shared/constants';
import { Organisations } from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';

@Component({
  selector: 'new-organisation-component',
  templateUrl: './new-organisation.component.html',
  styleUrls: ['new-organisation.component.scss']
})
export class NewOrganisationComponent {
  formMode = FormMode.CREATE;
  public loading: Observable<boolean>;

  constructor(private store: Store<any>) {
    this.loading = this.store.select(selectors.getCreating('organisations'));
  }

  submitOrg(org: OrganisationRequestInterface) {
    this.store.dispatch(Organisations.RequestCreateAction(org));
  }
}
